export default "__VITE_ASSET__fNqnT5U5__"